
import { useParams,useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import DynamicBanner from "./DynamicBanner";
import Dynamictext from "./Dynamictext";
import DynamicFaq from "./DynamicFaq";
import { BaseUrl } from "../../helper/BaseUrl";

export default function DynamicPage() {
  const { slug } = useParams();  
  const [serviceData, setServiceData] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

useEffect(() => {
    fetch(`${BaseUrl}/api/services/${slug}`)
      .then(res => {
        if (!res.ok) {
          navigate("/404");
          return;
        }
        return res.json();
      })
      .then(result => {
        if (!result?.data) {
          navigate("/404");
        } else {
          setServiceData(result.data);
        }
        setLoading(false);
      })
      .catch(() => {
        navigate("/404");
      });
  }, [slug, navigate]);

  if (!serviceData) return <p>Loading...</p>;


  return (
    <>
      <DynamicBanner serviceData={serviceData} />
      <Dynamictext secondDesc={serviceData.second_description}/>
      <DynamicFaq faqs={serviceData.faqs} />
    </>
  );
}




